module.exports = __webpack_public_path__ + "static/media/Disha-Khanted.a6893c84.png";